
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 477.3 477.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M238.7 477.3C106.9 477.3 0 370.4 0 238.5c0-63.3 25.2-124 69.9-168.8 93.3-93.1 244.5-93 337.6.4 93 93.2 93 244.1 0 337.3-44.6 44.9-105.4 70.1-168.8 69.9zm0-452.5C120.7 24.8 25 120.5 25 238.6c0 117.9 95.9 213.7 213.7 213.7 118 0 213.7-95.7 213.7-213.8 0-56.7-22.5-111-62.6-151.1-39.9-40.2-94.4-62.7-151.1-62.6z"}}),_c('path',{attrs:{"d":"M225.4 203.8c0 22.6-10.4 33.9-25.2 38.8 24.2 3.9 37.3 16.7 37.3 42.4 0 28.6-18.4 48-54.8 48h-57.2c-7.3 0-8.7-1.2-8.7-8.5V177.8h-3.4c-7.5-2.4-10.7-7.3-10.7-12.6 0-3.6 1.5-3.9 6.8-3.9h68.3c32.3.1 47.6 19.2 47.6 42.5zM139.3 181v52.8h35.1c17.2-.2 26.7-9.9 26.7-26.4 0-15.8-8.2-26.4-29.6-26.4h-32.2zm0 72.3v60.1h38.5c24.7 0 35.4-11.6 35.4-30.3 0-19.9-12.4-29.8-35.4-29.8h-38.5z"}}),_c('path',{attrs:{"d":"M304.2 336.1c-18.2 0-34.4-3.9-42.2-10.7-3.4-3.7-5.3-8.5-5.3-13.6s1.7-6.1 7.5-3.9c10.9 5.8 22.3 8.5 36.1 8.5 33.9 0 46.5-23.3 49.7-54.3-9 6.8-21.6 12.4-40.2 12.4-29.1 0-56.7-17-56.7-54.8 0-36.6 19.6-60.6 57.9-60.6 47.5 0 63 30.5 63 85.3 0 45.9-13.1 91.7-69.8 91.7zm46.8-95c-.5-44.9-13.3-62.3-40.2-62.3-20.1 0-34.4 14-34.4 39.5s16 36.6 35.6 36.6c16.9 0 30.7-6.8 39-13.8z"}})])
          )
        }
      }
    